export default __webpack_public_path__ + "static/media/diary-screenshot-03.02697a13.png";